import type { DashboardFinalRoundDto, FinalRoundType } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import dayjs from "dayjs"

const createFinalRoundMemberDto = (
  id: string,
  memberId: string,
  firstname: string,
  lastname: string,
  purchaseName: string,
  daysRemaining: number,
  sessionsLast30Days: number,
  remainingCount: number | null = null,
  totalCount: number | null = null,
  avatarUrl: string | null = null,
  type: FinalRoundType = "MEMBERSHIP",
): DashboardFinalRoundDto => ({
  id,
  boxMember: {
    id: memberId,
    firstname,
    lastname,
    status: "ACTIVE",
    avatar: avatarUrl ? { url: avatarUrl, hash: "hash", key: "key" } : null,
    username: `${firstname.toLowerCase()}${lastname.toLowerCase()}`,
    note: null,
    lastVisited: null,
    noShowPastMonth: null,
    activeOffers: [],
    archivedDate: null,
    inscriptionDate: dayjs().subtract(6, "months").toISOString(),
    archived: false,
    lastMembership: null,
  },
  purchaseName,
  remainingCount,
  totalCount,
  endDate: dayjs().add(daysRemaining, "days").toISOString(),
  sessionsLast30Days,
  type,
})

export const FINAL_ROUND_MEMBER_DEFAULT: DashboardFinalRoundDto = createFinalRoundMemberDto(
  "final-round-1",
  "member-final-1",
  "Liam",
  "Johnson",
  "Couple subscription plan",
  10,
  5,
  null,
  null,
  null,
  "MEMBERSHIP",
)

export const FINAL_ROUND_MEMBERS_LIST: DashboardFinalRoundDto[] = [
  // Memberships expiring soon (sorted by days remaining ascending - most critical first)
  FINAL_ROUND_MEMBER_DEFAULT,
  createFinalRoundMemberDto("final-round-2", "member-final-2", "Emma", "Wilson", "Monthly Unlimited", 3, 12),
  createFinalRoundMemberDto("final-round-3", "member-final-3", "Noah", "Brown", "Annual Membership", 5, 8),
  createFinalRoundMemberDto("final-round-4", "member-final-4", "Olivia", "Davis", "Quarterly Pass", 12, 15),
  createFinalRoundMemberDto("final-round-5", "member-final-5", "William", "Garcia", "Monthly Unlimited", 14, 6),

  // Class passes with low tickets (2 or less remaining)
  createFinalRoundMemberDto(
    "final-round-6",
    "member-final-6",
    "Sophia",
    "Martinez",
    "10 Session Pack",
    8,
    4,
    2,
    10,
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-7",
    "member-final-7",
    "James",
    "Anderson",
    "5 Session Pack",
    5,
    3,
    1,
    5,
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-8",
    "member-final-8",
    "Isabella",
    "Thomas",
    "20 Session Pack",
    18,
    10,
    2,
    20,
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-9",
    "member-final-9",
    "Benjamin",
    "Jackson",
    "10 Session Pack",
    40,
    7,
    1,
    10,
    "https://i.pravatar.cc/150?u=benjamin",
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-10",
    "member-final-10",
    "Mia",
    "White",
    "5 Session Pack",
    70,
    2,
    2,
    5,
    "CLASS_PASS",
  ),

  // More memberships
  createFinalRoundMemberDto(
    "final-round-11",
    "member-final-11",
    "Ethan",
    "Harris",
    "Monthly Unlimited",
    7,
    9,
    null,
    null,
    "https://i.pravatar.cc/150?u=ethan",
    "MEMBERSHIP",
  ),
  createFinalRoundMemberDto(
    "final-round-12",
    "member-final-12",
    "Charlotte",
    "Clark",
    "Couple subscription plan",
    1,
    11,
    null,
    null,
    null,
    "MEMBERSHIP",
  ),
  createFinalRoundMemberDto(
    "final-round-13",
    "member-final-13",
    "Alexander",
    "Lewis",
    "Annual Membership",
    2,
    14,
    null,
    null,
    null,
    "MEMBERSHIP",
  ),

  // More class passes
  createFinalRoundMemberDto(
    "final-round-14",
    "member-final-14",
    "Amelia",
    "Robinson",
    "10 Session Pack",
    6,
    5,
    2,
    10,
    "https://i.pravatar.cc/150?u=amelia",
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-15",
    "member-final-15",
    "Daniel",
    "Walker",
    "20 Session Pack",
    25,
    8,
    1,
    20,
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-16",
    "member-final-16",
    "Harper",
    "Young",
    "5 Session Pack",
    4,
    6,
    1,
    5,
    "CLASS_PASS",
  ),
  createFinalRoundMemberDto(
    "final-round-17",
    "member-final-17",
    "Michael",
    "King",
    "Monthly Unlimited",
    9,
    7,
    null,
    null,
    null,
    "MEMBERSHIP",
  ),
  createFinalRoundMemberDto(
    "final-round-18",
    "member-final-18",
    "Evelyn",
    "Wright",
    "10 Session Pack",
    11,
    4,
    2,
    10,
    "MEMBERSHIP",
  ),
]
